import request from '@/axios/index.js'
const uri = '/user/goldseller/';

export function signOut(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: uri+'signOut'
    })
}

export function signIn(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: uri+'signIn'
    })
}
export function borrowedContractList(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: uri+'borrowedContractList'
    })
}


// WEBPACK FOOTER //
// ./src/api/goldseller.js